import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Icon as i } from "../Icon/index.js";
import { useRemainingCharsCount as R } from "./hooks/useRemainingCharsCount.js";
import { TextInputSuccessMessage as E, TextInputErrorMessage as k, TextInputTipMessage as v, TextInputAlertMessage as N, TextInputContainer as j, PrefixContainer as y, Input as A, CharsCountContainer as B, CharacterCounter as P, InputIcon as G } from "./style.js";
import { TextInputSkeletonContainer as _, TextInputSkeletonContainer as $, textInputBaseMessageStyle as L } from "./style.js";
import { TextInputMessageStatus as o } from "./types.js";
import { Check as O, CircleExclamation as U, CircleInfo as W, TriangleExclamation as q } from "@pelando/fontawesome/icons";
import { useTranslation as w } from "../../hooks/useTranslation/index.js";
const z = ({ type: r, text: t }) => {
  const { t: n } = w("common");
  return {
    [o.SUCCESS]: /* @__PURE__ */ a(E, { children: [
      /* @__PURE__ */ e(
        i,
        {
          icon: O,
          "aria-label": n("text-input-success-message-aria-label")
        }
      ),
      t
    ] }),
    [o.ERROR]: /* @__PURE__ */ a(k, { children: [
      /* @__PURE__ */ e(
        i,
        {
          icon: U,
          "aria-label": n("text-input-error-message-aria-label")
        }
      ),
      t
    ] }),
    [o.TIP]: /* @__PURE__ */ a(v, { children: [
      /* @__PURE__ */ e(
        i,
        {
          icon: W,
          "aria-label": n("text-input-tip-message-aria-label")
        }
      ),
      t
    ] }),
    [o.WARNING]: /* @__PURE__ */ a(N, { children: [
      /* @__PURE__ */ e(
        i,
        {
          icon: q,
          "aria-label": n("text-input-alert-message-aria-label")
        }
      ),
      t
    ] })
  }[r];
};
function X({
  type: r = "text",
  innerRef: t,
  invalid: n,
  message: s,
  rounded: I,
  prefix: u,
  showRemainingChars: h,
  maxLength: p,
  onChange: d,
  icon: l,
  iconLabel: c,
  onIconClick: m,
  disabled: C,
  className: g,
  characterCounter: x,
  brandIcon: T,
  ...f
}) {
  const { handleInputChange: S, remainingCharsCount: b, hasRemainingCharsCount: M } = R({
    maxLength: p,
    onChange: d,
    showRemainingChars: h,
    type: r
  });
  return /* @__PURE__ */ a("div", { children: [
    /* @__PURE__ */ a(
      j,
      {
        "aria-invalid": n,
        "aria-disabled": C,
        style: I ? { "--rounded": "18px" } : void 0,
        className: g,
        children: [
          u && /* @__PURE__ */ e(y, { children: u }),
          /* @__PURE__ */ e(
            A,
            {
              ...f,
              type: r,
              disabled: C,
              maxLength: p,
              onChange: S,
              ref: t
            }
          ),
          M && /* @__PURE__ */ e(B, { children: b }),
          x ? /* @__PURE__ */ e(P, { children: x }) : l && /* @__PURE__ */ e(
            G,
            {
              icon: l,
              title: c ?? l.iconName,
              role: m ? "button" : "img",
              "aria-label": c,
              onClick: m,
              "data-icon-color": T
            }
          )
        ]
      }
    ),
    s && /* @__PURE__ */ e(z, { ...s })
  ] });
}
export {
  P as CharacterCounter,
  B as CharsCountContainer,
  A as Input,
  G as InputIcon,
  z as MessageByInputStatus,
  y as PrefixContainer,
  X as TextInput,
  N as TextInputAlertMessage,
  j as TextInputContainer,
  k as TextInputErrorMessage,
  o as TextInputMessageStatus,
  _ as TextInputSkeleton,
  $ as TextInputSkeletonContainer,
  E as TextInputSuccessMessage,
  v as TextInputTipMessage,
  L as textInputBaseMessageStyle
};
